var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardLayout',{attrs:{"clickable":""},on:{"cardClick":function($event){return _vm.$emit('optionSelected')}}},[_c('GetnetCardContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }